/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, Swiper, gsap) => {
        /*
        |
        | Banner
        |-----------
        */
        $("#home-banner-selector, #home-banner-selector-child").on('click', function (e) {
            $(this).toggleClass("active");
        });


        // let bannerTl = gsap.timeline({ paused: true });
        // bannerTl.to("#header, .home-banner-content, .home-banner .scrollDown", 0.4, { opacity: 0 }, 0)
        // bannerTl.to(".home-banner-bg img", 5, { scale: 2 }, 1);
        // bannerTl.to(".home-banner .wave svg", 2, { y: '-=90vh', scale: 3 }, 1);


        $("#home-banner-selector .selector-outer li > a").on('click', function (e) {
            // e.preventDefault();


            let text = $(this).text();
            $(".home-banner .selector-inner .choosen").text(text);


            if ($(this).hasClass("hasChilds")) {
                $("#home-banner-selector-child").fadeIn();
            }
            else {
                $("#home-banner-selector-child").fadeOut();
            }
        });

        $("#home-banner-selector-child .selector-outer li > a").on('click', function (e) {
            let text = $(this).text();
            $(".home-banner .selector-inner .choosenChild").text(text);
        })

        /*
        |
        | Home Description animation leafs
        |-----------
        */
        if ($(".home-description-leafs")[0]) {
            gsap.to('.home-description-leafs > g', 3, { y: '-=20', stagger: 0.05, yoyo: true, repeat: -1, ease: "power2.inOut" })
        }


    }
}
